import React from "react";
import { Modal } from "@veneer/core";

interface EvaluationModalProps {
  show: boolean;
  onClose: () => void;
  t: (key: string) => string;
  children: React.ReactNode;
}

export const EvaluationModal: React.FC<EvaluationModalProps> = ({
  show,
  onClose,
  children,
  t,
}) => {
  return (
    <Modal
      className="evaluationModal"
      show={show}
      onClose={onClose}
      closeButton={false}
      align="center"
      title={t("header.evaluation")}
    >
      {children}
    </Modal>
  );
};
